// both, ak-forwarded and ak-entrypoint are read and used
// by CatalogOrder forms and sent to order api
export const setupSessionStorage = () => {
  if (!sessionStorage.getItem("ak-forwarded")) {
    var val = "direct";
    if (document.referrer.length > 0) {
      val = document.referrer;
    }
    sessionStorage.setItem("ak-forwarded", val);
  }

  if (!sessionStorage.getItem("ak-entrypoint")) {
    const val = document.location.href;
    sessionStorage.setItem("ak-entrypoint", val);
  }
}
